import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
    FieldLabel,
    FormFieldComponentProps,
    InputTextComponent,
} from '@sheerid/jslib';

export const MarinerNumberComponent = ({
    value,
    isErrored,
    errorId,
    onChange,
    intl,
    placeholder = '',
}: FormFieldComponentProps) => (
    <div className="sid-field sid-mariner-number">
        <div className="sid-l-space-top-md" />
        <FieldLabel
            text={<FormattedHTMLMessage id="marinerNumber" defaultMessage="{marinerNumber}" />}
            htmlForLabel="sid-mariner-number"
            id="sid-mariner-number-label"
            displayClasses={placeholder && 'sid-h-screen-reader-only'}
        />

        <InputTextComponent
            id="mariner-number"
            isErrored={isErrored}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            placeholder={
                placeholder
                || intl.formatMessage({ id: 'marinerNumberPlaceholder', defaultMessage: '{marinerNumberPlaceholder}' })
            }
            refId="marinerNumber"
            value={value}
            required
            aria-labelledby="sid-mariner-number-label"
        />

        {isErrored ? (
            <div className="sid-field-error" id={`${errorId}`}>
                <FormattedHTMLMessage id={`errorId.${errorId}`} defaultMessage="{errorId.marinerNumber}" />
            </div>
        ) : null}

        <div className="sid-field__marinerExplanation-explanation">
            <FormattedHTMLMessage
                id="marinerExplanation"
                defaultMessage="{marinerExplanation}"
            />
        </div>
    </div>
);

export const MarinerNumber = injectIntl(MarinerNumberComponent);
